import { render, staticRenderFns } from "./KeyValueEdit.vue?vue&type=template&id=06ae350b"
import script from "./KeyValueEdit.vue?vue&type=script&lang=js"
export * from "./KeyValueEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports